import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

type PropTypes = {
  content_to_copy: string;
  only_show_on_hover?: boolean;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'CopyButton',
  props: {
    content_to_copy: null,
    only_show_on_hover: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { content_to_copy: string, only_show_on_hover: boolean };



const is_copying = ref(false);
const is_content_hovered = ref(false);
const show_button = computed(
  () => !props.only_show_on_hover || is_content_hovered.value,
);

async function copy_content_to_clipboard() {
  await navigator.clipboard.writeText(props.content_to_copy);

  is_copying.value = true;

  // Wait to set icon back
  setTimeout(() => {
    is_copying.value = false;
  }, 3000);
}

return { __sfc: true,props, is_copying, is_content_hovered, show_button, copy_content_to_clipboard }
}

})